export const categories: string[] = [
  "Leczenie",
  "Statystyki",
  "Lekarze",
  "Pomoc",
  "Petycje",
  "Kampanie",
  "Wydarzenia",
];
